import { makeRpcCall } from "../core/rpc.core";

export const callRpc = async <P, T>(
  method: string,
  params?: P,
  init?: RequestInit,
  id: string = "1"
): Promise<T> => {
  const { headers = {}, ...rest } = init || {};
  
  return makeRpcCall<P, T>(
    method,
    params,
    headers as Record<string, string>,
    rest,
    id
  );
};
